/**
 * Feature flag constants.
 *
 * These feature flags are managed in WorkOS and used to control access
 * to various features in the application.
 *
 * Values must match the feature flag names configured in WorkOS.
 */
export const FeatureFlag = {
  // Intake workflow feature flags
  INTAKE_ELIGIBILITY_CHECK_SUPPORT: 'intake-eligibility-check-support',
  INTAKE_PRIOR_AUTH_SUPPORT: 'intake-prior-auth-support',
  INTAKE_READY_TO_CALL_SUPPORT: 'intake-ready-to-call-support',
  INTAKE_SCHEDULING_SUPPORT: 'intake-scheduling-support',
  INTAKE_DOC_UPLOAD: 'intake-doc-upload',
  INTAKE_WELLSKY_SCHEDULING: 'intake-shows-kinnser-option',
  INTAKE_ROGER_SCHEDULING: 'intake-shows-roger-option',

  // Medical coding feature flags
  MEDICAL_CODING_OE_DATE_SEVERITY_UI: 'medical-coding-oe-date-severity-ui',

  // Reporting feature flags
  ADOPTION_REPORT_BY_BRANCH: 'adoption-report-by-branch',

  // Admin feature flags
  ADMIN_WORKSHEET_GOALS: 'admin-worksheet-goals',
} as const;

export type FeatureFlagType = (typeof FeatureFlag)[keyof typeof FeatureFlag];
